import getFeatureFlags, {
  isAutomaticAccountLoginEnabled
} from '../featureflags'
import logger from './logger'

export const getAccountFeatureFlags = (accountId, accountName) => {
  if (!accountId && accountName) {
    logger.log('[CTI-Login] No accountId available, using account name param for auto login', {
      accountName
    })
    return Promise.resolve(true)
  }

  return accountId ? getFeatureFlags(accountId).then(flags => isAutomaticAccountLoginEnabled(flags)) : Promise.resolve(false)
}

export default getAccountFeatureFlags
